module.exports = __webpack_public_path__ + "img/playkids-learning-logo.e88fce41.png";